<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'VQuestionEditor',
  extends: compoment
}
</script>
